import { createRoot } from 'react-dom/client';
import { createElement } from 'react';
import App from '../components/App';

export const bootstrap = () => {
  const container = document.getElementById('react-root');
  const root = createRoot(container!);
  root.render(createElement(App));
};
